import { CoreDomainSearchStore, StatusesModule } from '@wix/domains-search-suite';
import React from 'react';
import { AlternativesMessage } from '../AlternativesMessage';
export const SITE_LEVEL_ALTERNATIVES_DATA_HOOK = 'site-level-alternatives';
export const SiteLevelDomainTaken = props => {
  const submittedDomain = CoreDomainSearchStore.useSubmittedDomain();
  if (submittedDomain) {
    return /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.DomainIsTaken, props);
  }
  return /*#__PURE__*/React.createElement(AlternativesMessage, {
    domainName: props.domainName,
    dataHook: SITE_LEVEL_ALTERNATIVES_DATA_HOOK
  });
};
//# sourceMappingURL=SiteLevelDomainTaken.js.map